<template>
  <div class="flex grow flex-col">
    <slot />
  </div>
  <ModalContainer />
  <CookieConsentBanner />
</template>
